module.exports = __webpack_public_path__ + "img/welcomelanding_icon1.57e7d3db.png";